import React, { useEffect, useState } from "react";
import { fetchTopRatedTokens } from "../services/apiService";

const timeframes = ["5m", "1h", "6h", "24h"];

const dummyData = [
    {
        name: "Ethereum",
        symbol: "ETH",
        image_url: "/images/ETH.png",
        price: 3100,
        price5m: 3120,
        price1h: 3085,
        price6h: 3050,
        price24h: 2980,
        variation5m: 0.65,
        variation1h: 1.45,
        variation6h: 2.83,
        variation24h: 4.03,
        volume5m: 21000000,
        volume1h: 150000000,
        volume6h: 580000000,
        volume24h: 2100000000
    },
    {
        name: "Solana",
        symbol: "SOL",
        image_url: "/images/SOL.png",
        price: 150,
        price5m: 152,
        price1h: 148,
        price6h: 143,
        price24h: 138,
        variation5m: 1.33,
        variation1h: 2.70,
        variation6h: 4.89,
        variation24h: 8.70,
        volume5m: 9000000,
        volume1h: 70000000,
        volume6h: 210000000,
        volume24h: 900000000
    },
    {
        name: "Pepe",
        symbol: "PEPE",
        image_url: "/images/PEPE.png",
        price: 0.000012,
        price5m: 0.0000121,
        price1h: 0.0000118,
        price6h: 0.0000114,
        price24h: 0.0000109,
        variation5m: 0.83,
        variation1h: 1.70,
        variation6h: 4.39,
        variation24h: 10.09,
        volume5m: 300000,
        volume1h: 2500000,
        volume6h: 8800000,
        volume24h: 32000000
    }
];

const TopTradedTokens = () => {
    const [tokens, setTokens] = useState([]);
    const [timeframe, setTimeframe] = useState("5m");

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchTopRatedTokens();
            setTokens(data && data.length > 0 ? data : dummyData);
        };
        fetchData();
    }, []);

    const getFormattedVolume = (volume) => {
        if (!volume) return "-";
        if (volume >= 1e9) return `${(volume / 1e9).toFixed(2)}B`;
        if (volume >= 1e6) return `${(volume / 1e6).toFixed(2)}M`;
        if (volume >= 1e3) return `${(volume / 1e3).toFixed(1)}K`;
        return volume.toFixed(0);
    };

    const getVariationColor = (value) =>
        value > 0 ? "text-green-400" : value < 0 ? "text-red-400" : "text-gray-300";

    const getTokenMetric = (token, metric) => token[`${metric}${timeframe}`] ?? token[metric];

    return (
        <div className="bg-gradient-to-br from-black via-gray-900 to-black shadow-md">
            <section className="text-white py-8 px-4 sm:px-6 lg:px-12">
                <div className="w-full">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row justify-between items-center mb-4">
                        <h2 className="text-3xl font-bold text-cyan-400 mb-2 md:mb-0">
                            Top Traded Tokens</h2>
                        <div className="flex gap-2">
                            {timeframes.map((tf) => (
                                <button
                                    key={tf}
                                    className={`px-3 py-1 text-base rounded-full font-semibold border ${timeframe === tf
                                        ? "bg-cyan-500 text-white"
                                        : "bg-gray-800 border-gray-600 text-gray-300"
                                        }`}
                                    onClick={() => setTimeframe(tf)}
                                >
                                    {tf}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Inner container with table */}
                    <div className="bg-white/5 border border-cyan-500 rounded-xl p-4 backdrop-blur-sm shadow-lg">
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left text-gray-300 table-auto">
                                <thead className="bg-gray-800 text-cyan-300 text-sm font-semibold uppercase">

                                    <tr>
                                        <th className="py-2 px-3">Name</th>
                                        <th className="py-2 px-3">Price</th>
                                        <th className="py-2 px-3">Change</th>
                                        <th className="py-2 px-3">Volume</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-700">
                                    {tokens.map((token, index) => {
                                        const price = getTokenMetric(token, "price");
                                        const variation = getTokenMetric(token, "variation");
                                        const volume = getTokenMetric(token, "volume");

                                        return (
                                            <tr key={index} className="hover:bg-gray-900">
                                                <td className="py-2 px-3 flex items-center gap-2">
                                                    <img
                                                        src={token.image_url}
                                                        alt={token.symbol}
                                                        onError={(e) => (e.target.src = "/images/default.png")}
                                                        className="w-4 h-4 rounded-full"
                                                    />
                                                    <span>
                                                        {token.name} ({token.symbol})
                                                    </span>
                                                </td>
                                                <td className="py-2 px-3">${Number(price).toPrecision(6)}</td>
                                                <td className={`py-2 px-3 font-medium ${getVariationColor(variation)}`}>
                                                    {variation > 0 ? "+" : ""}
                                                    {variation?.toFixed(2)}%
                                                </td>
                                                <td className="py-2 px-3">
                                                    ${getFormattedVolume(Number(volume))}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default TopTradedTokens;
